import type { AppListenerMiddleware } from "@src/store";
import { setupBuilderLifecycleListener } from "./builderLifecycle/setupBuilderLifecycleListener";
import { setupStatsListener } from "./builderLifecycle/setupStatsListener";
import { setupDeployListener } from "./setupDeployListener";

export function setupCommonListener(middleware: AppListenerMiddleware) {
  setupBuilderLifecycleListener(middleware);
  setupStatsListener(middleware);
  setupDeployListener(middleware);
}
